import { useState, useEffect } from 'react';
// TODO: Get AV News from new source
import { getUserMessages } from '../../../shared/services/apiGateway';

function useUserMessages(userid = '') {
  const [userMessages, setUserMessages] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      const response = await getUserMessages(userid, abortController.signal);
      if (!ignore && response !== 'aborted' && response) {
        setUserMessages(response);
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [userid]);

  return [userMessages, setUserMessages];
}

export default useUserMessages;
